export const PRIMARY_BOOK_BUTTON_TRACKING = {
  SURFACE: 'profile',
  VARIANT_LABEL: 'primary button variant B',
} as const

export const PRIMARY_BOOK_BUTTON_DEVICE = {
  DESKTOP: 'desktop',
  MOBILE: 'mobile',
} as const
